export const LINKS = {
    TERMS: 'https://gsk-qualitysuite.veevavault.com/ui/#doc_info/4651305',
    PRIVACY: 'https://gsk-qualitysuite.veevavault.com/ui/#doc_info/4651293',
    PROCEDURE: 'https://gsk-qualitysuite.veevavault.com/ui/#doc_info/1100412/9/0',
    POLICY: 'https://gsk-qualitysuite.veevavault.com/ui/#doc_info/1100247/9/0?anQS=page1&annotate=false',
    APP: {
        ANDROID: 'https://portal.manage.microsoft.com/apps/c0f28bf0-1c4b-420c-8ad5-0a8b08c38cbb',
        IOS: 'https://portal.manage.microsoft.com/WebCP/Apps/920c25fd-a320-4acd-830d-756bc3aaedbf',
        HOW_TO: {
            ANDROID: 'https://servicenow.gsk.com/home?id=kb_article&sysparm_article=KB5335554',
            IOS: 'https://servicenow.gsk.com/home?id=kb_article&sysparm_article=KB5240416',
        },
    },
}

export const HEADER_HEIGHT = {
    desktop: '74px',
    mobile: '54px',
}

export const TEXTAREA_LIMIT = 250
